import { gql } from '@apollo/client';

export const deleteContactListFromFacility = gql`
  mutation deleteContactListFromFacility($id: String, $contactListId: String) {
    deleteContactListFromFacility(id: $id, contactListId: $contactListId) {
      id
      ContactListId
      managementContactListId
      Locations {
        id
        state
        county
        township
      }
      address
      facilityName
      facilityUid
      FacilityType {
        id
        name
      }
      AORs {
        id
        name
      }
      Company {
        id
        name
      }
      businessUnit {
        id
      }
      notes
      phone
      altPhone
      gps
      scadaId
      flocNumber
      timezone
      updater
      deletedAt
      version
      area {
        id
        name
        region {
          id
          name
        }
      }
      owner {
        id
        firstName
        lastName
        nickName
      }
    }
  }
`;
